module.exports = __webpack_public_path__ + "5a7d90083551722e99d7a78f4d0d523b.svg";